// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1Cz07","errorLogs":"styles_errorLogs__2WWy3"};